<mat-dialog-content class="h-full min-w-128 max-w-screen-50 overflow-hidden px-0 text-center lg:max-w-[35vw]">
    <div class="py-6">
        <mat-icon
            *ngIf="alertConfig?.type === 'warning'"
            class="h-40 w-40"
            svgIcon="streamline-regular:alert-circle"
        ></mat-icon>
    </div>

    <div class="flex flex-col gap-3 px-10">
        <h2 [innerHTML]="alertConfig?.title"></h2>

        <span class="max-w-110 text-medium truncate whitespace-pre-line" [innerHTML]="alertConfig?.message"></span>
    </div>
</mat-dialog-content>

<mat-dialog-actions class="py-6">
    <div class="flex w-full flex-row-reverse items-center justify-center gap-4">
        <ng-container *ngFor="let button of alertConfig?.buttons ?? []; let i = index">
            <button *ngIf="i === 0" mat-raised-button class="confirm-button" (click)="confirm()">
                {{ button }}
            </button>

            <button *ngIf="i !== 0" mat-button class="dismiss-button" (click)="close()">
                {{ button }}
            </button>
        </ng-container>
    </div>
</mat-dialog-actions>
